<template>
    <div>
        <p>
            <button @click="reduce">--</button>
            <input type="text" v-model="quantity" @keyup="inputHandler">
            <button @click="add">++</button>
        </p>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                quantity: 0
            }
        },
        props: {
            max: {
                type: Number,
                default: 5
            },
            min: {
                type: Number,
                default: 1
            },
        },
        methods: {
            add() {
                if(this.quantity>=this.max){
                    this.quantity =this.max
                    return
                }
                this.quantity++;
                this.$emit('counter',this.quantity);

            },
            reduce() {
                
                if(this.quantity<=this.min){
                    this.quantity =this.min
                    return
                }
                this.quantity--;
                this.$emit('counter',this.quantity);
            },
            inputHandler() {
                
                // console.log(this.quantity.match())
                if(this.quantity>=this.max){
                    this.quantity = this.max
                }else if(this.quantity<=this.min){
                    this.quantity = this.min
                }else if(/\D/g.test(this.quantity)){
                    this.quantity = Number(this.quantity.replace(/\D/g,''))
                }
                this.$emit('counter',this.quantity);
            }
        },
        created() {
            this.inputHandler()
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/details/components/Counter.vue